import { useEffect, useMemo } from "react";
import InAppSpy from "inapp-spy";
import { useI18n } from "@/i18n";

const H = 56;
const TXT = {
  fr: {
    text: "Ouvre BeatCut dans Safari ou Chrome pour importer et télécharger tes vidéos. Touche ••• puis « Ouvrir dans le navigateur ».",
    open: "Ouvrir dans Chrome",
  },
  en: {
    text: "Open BeatCut in Safari or Chrome to import and download your videos. Tap ••• then “Open in browser”.",
    open: "Open in Chrome",
  },
};

export function detectInApp() {
  try {
    if (new URLSearchParams(window.location.search).has("ext")) return { isInApp: false };
    return InAppSpy();
  } catch {
    return { isInApp: false };
  }
}

export default function InAppBanner() {
  const { lang } = useI18n();
  const spy = useMemo(detectInApp, []);
  const android = /Android/i.test(navigator.userAgent || "");
  useEffect(() => {
    if (!spy.isInApp) return;
    document.documentElement.style.setProperty("--bc-inapp-h", `${H}px`);
    return () => document.documentElement.style.removeProperty("--bc-inapp-h");
  }, [spy.isInApp]);
  if (!spy.isInApp) return null;
  const t = TXT[lang] || TXT.fr;
  const u = new URL(window.location.href);
  u.searchParams.set("ext", "1");
  const intent = `intent://${u.host}${u.pathname}${u.search}#Intent;scheme=https;package=com.android.chrome;end`;
  return (
    <div
      className="sticky top-0 z-[9996] bg-background border-b border-primary/60 text-foreground flex items-center gap-3 px-4"
      style={{ minHeight: H }}
      data-testid="inapp-banner"
      role="status"
    >
      <span className="h-2 w-2 shrink-0 bg-primary" aria-hidden="true" />
      <p className="flex-1 text-xs leading-snug py-2" data-testid="inapp-banner-text">{t.text}</p>
      {android && (
        <a
          href={intent}
          data-testid="inapp-open-chrome"
          className="shrink-0 rounded-full bg-primary text-white font-osd text-[10px] tracking-[0.08em] uppercase px-3 h-9 inline-flex items-center"
        >
          {t.open}
        </a>
      )}
    </div>
  );
}
